import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';
import * as moment from 'moment';
import { saveAs } from "file-saver";
@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private assignment = new Subject<any>();

  private markinfScheme = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient
  ) { }



  addDocument(data): Observable<any> {

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "document", data).subscribe((res: any) => {
        console.log("Edited form: ", res);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }


  getDocumentDetails(jobId): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "document?title=GP&_id=" + jobId).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }




  updateForm(data) {


    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "document", data).subscribe((res: any) => {
        console.log("Edited form: ", res);
        observer.next(res.data);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }


  getLpDocuments(jobId) {
    console.log("THIS IS THE JOB ID DATA", jobId)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "document?title=LP&_id=" + jobId).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }

  getLernerForm(learnerId) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "document?title=LP&_learnerId=" + learnerId).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }


  getLearnerIlpForm(data) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "document?title=ILP&_ilp=" + data).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }

  getLearnerRapForm(data) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "document?title=RAP&_rap=" + data).subscribe((res: any) => {
        console.log("Raps Form Data", res);
        observer.next(res);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }


  getIqaFormValue(jobId) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "document?title=IQA&_id=" + jobId).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }

  getIqaPlanFormValue(jobId) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "document?title=IQAPlan&_id=" + jobId).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }
  /**
   * ***************************************
  //Medical Checklist Dowload Services
  ********************************************
  */
  checklistdowload(Id) {
    console.log("your dowload check list ID is:", Id)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + 'document/download?_id=' + Id).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });

  }
  //*********************************

  getMedicalChecklistFormValue(jobId) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "document?title=medicalChecklist&_id=" + jobId).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }


  getDAChecklistFormValue(jobId) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "document?title=DAChecklist&_id=" + jobId).subscribe((res: any) => {
        console.log("Get Courses : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        observer.error(err)

      }, () => {
        observer.complete()
      })
    });
  }




  updateMarkingScheme(data) {
    console.log("Call this");

    this.markinfScheme.next(data)
  }


  markingSchemeObservable(): Observable<any> {
    return this.markinfScheme.asObservable();
  }

  /**
   * @param type
   * @param learnerFormData  
   * @param learnerName 
   * Down load ilp form for learner 
   */
  downloadIlpForm(type, learnerFormData, job) {
    console.log("learner form data in service", learnerFormData);

    return new Observable<any>((observer) => {
      console.log("Observable");



      let finalArray = []
      if (type == 'Level2') {
        // headers.pop()
        if (learnerFormData.personalDetails) {
          finalArray.push(['personalDetails'], ['\r'], ['\r'])
          finalArray.push(['LearnerDetails'], ['\r'])
          let headers = ['Learner Name', 'ULN', 'Trainer', 'Course', 'Start Date', 'ExpectedEndDate', 'ActualEndDate', 'Duration']
          finalArray.push(headers, ['\r'])
          let item = learnerFormData.personalDetails
          let temp = []
          temp.push(item.name, item.uln, item.trainer[0].name, item.course, moment(item.startDate).format("DD-MM-YYYY"), moment(item.expectedEndDate).format("DD-MM-YYYY"), moment(item.actualEndDate).format("DD-MM-YYYY"), item.duration)
          console.log("what is the total temp value", temp);
          finalArray.push(temp, ['\r'], ['\r'])
        }
        if (learnerFormData.qualificationsForm) {
          finalArray.push(['Qualification Details'], ['\r'])
          let headers = ['Qualification', 'Learning Aim No', 'Awarding Organisation']
          finalArray.push(headers, ['\r'])

          let item = learnerFormData.qualificationsForm
          let temp = []
          let temp1 = []
          temp.push(item.qualification, item.learningAim, item.awardingOrg)
          finalArray.push(temp, ['\r'])
          temp1.push(item.qualification1, item.learningAim1, item.awardingOrg1)
          finalArray.push(temp1, ['\r'], ['\r'])
        }
        if (learnerFormData.assessment) {
          finalArray.push(['Initial Assessment / Diagonastic Results'], ['\r'])
          let headers = ['Subject', 'Level']
          finalArray.push(headers, ['\r'])

          let item = learnerFormData.assessment
          let temp = []
          let temp1 = []
          temp.push('English', item.engLevel)
          finalArray.push(temp, ['\r'])
          temp1.push('Maths', item.mathLevel)
          finalArray.push(temp1, ['\r'], ['\r'])
        }

        if (learnerFormData.aln) {
          finalArray.push(['Additional Learning Needs'], ['\r'])
          let headers = ['None', 'ASN - Maths', 'ALN - both', 'ASN - English', 'ASN']
          finalArray.push(headers, ['\r'])

          let item = learnerFormData.aln
          let temp = []
          // let temp1 = []
          temp.push(item.aln1, item.aln2, item.aln3, item.aln4, item.aln5)
          finalArray.push(temp, ['\r'], ['\r'])
          // temp1.push('Maths', item.mathLevel)
          // finalArray.push(temp1, ['\r'], ['\r'])
        }

        if (learnerFormData.IAG) {
          let item = learnerFormData.IAG
          finalArray.push(['Three Stages of Information, Advice and Guidance (IAG)'], ['\r'], ['\r'])
          let title = "\"" + " Getting into Learning: To be recorded as part of learner sign up e.g. ensuring programme is appropriate, assessing current skills and needs, identifying career goals and aspirations, discussing concerns and agreeing how needs will be met to ensure progression and learning style to meet objectives." + "\""
          let title1 = "\"" + "Review: To be recorded at mid-point of programme e.g. providing ongoing support to help maintain pace and momentum, reviewing goals and agreeing future options and actions required." + "\""
          let title2 = "\"" + "Moving on from Learning: To be recorded on learner exit e.g. discussing progression options into further learning and development that is appropriate to the learners needs what actions are required within appropriate timescales. Signposting learners to appropriate resources and organisations if applicable." + "\""
          let temp
          temp = title.replace(/,/g, " ").split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next);
          // console.log("description value============", temp);
          if (item.value1) {
            finalArray.push([temp], ['\r'])
            finalArray.push(['Comments'], ['\r'])
            finalArray.push([item.comment1], ['\r'])
            finalArray.push(["\"" + item.value1.replace(/,/g, "|").split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
            let firstDate = []
            let secondDate = []
            firstDate.push('LearnerDate', moment(item.learnerDate1).format("DD-MM-YYYY"))
            finalArray.push(firstDate, ['\r'])
            secondDate.push('TrainerDate', moment(item.trainerDate1).format("DD-MM-YYYY"))
            finalArray.push(secondDate, ['\r'])
          }
          if (item.value2) {
            let temp1 = title1.replace(/,/g, "|").split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next);
            finalArray.push([temp1], ['\r'])
            finalArray.push(['Comments'], ['\r'])
            finalArray.push([item.comment2], ['\r'])
            finalArray.push(["\"" + item.value2.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
            let firstDate = []
            let secondDate = []
            firstDate.push('LearnerDate', moment(item.learnerDate2).format("DD-MM-YYYY"))
            finalArray.push(firstDate, ['\r'])
            secondDate.push('TrainerDate', moment(item.trainerDate1).format("DD-MM-YYYY"))
            finalArray.push(secondDate, ['\r'])
          }
          if (item.value3) {
            let temp1 = title2.replace(/,/g, "|").split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next);
            finalArray.push([temp1], ['\r'])
            finalArray.push(['Comments'], ['\r'])
            finalArray.push([item.comment3], ['\r'])
            finalArray.push(["\"" + item.value3.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
            let firstDate = []
            let secondDate = []
            firstDate.push('LearnerDate', moment(item.learnerDate3).format("DD-MM-YYYY"))
            finalArray.push(firstDate, ['\r'])
            secondDate.push('TrainerDate', moment(item.trainerDate3).format("DD-MM-YYYY"))
            finalArray.push(secondDate, ['\r'], ['\r'])
          }
        }

        if (learnerFormData.responsibility) {
          let item = learnerFormData.responsibility
          finalArray.push(['Responsibilities'], ['\r'], ['\r'])
          finalArray.push(['The Learners Responsibilities', 'The Training Providers Responsibilities'], ['\r'])
          let title1 = "\"" + 'In both working and training to be,diligent and punctual, to attend courses,keep records and contribute to the review process, undertake assessments in order to achieve Individual Learning Plan objectives and keep the employer informed of progress towards those objectives' + "\""
          let temp1 = title1.replace(/,/g, " ")
          let title8 = 'To check that the contents of the Individual Learning Plan fulfil the national and industry / sector agreed criteria for the programme.'
          finalArray.push(["\"" + temp1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title8.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let titel2 = 'At all times to behave in a safe and responsible manner and in accordance with the requirements of health and safety legislation relating to the individuals responsibilities and to promote and act in the employers best interests.'
          let title9 = 'To conduct a progress review with the learner and employer at least every 8 weeks.'
          finalArray.push(["\"" + titel2.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title9.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title3 = 'Commit to making sure evidence is submitted in line with SMART targets.'
          let title10 = 'To deliver the programme as described in this plan, and in line with the appropriate framework awarding organisation and end point assessment (if applicable) requirements.'
          let temp10 = title10.replace(/,/g, " ")
          finalArray.push(["\"" + title3.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + temp10.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title4 = 'Communicate all non-attendance or session changes within a timely manner.'
          let title11 = 'To ensure that the training meets the requirements set out in the contract between the Training Provider and the Skills Funding Agency, in particular in relation to the quality assurance process including health and safety obligations.'
          let temp11 = title11.replace(/,/g, " ")
          finalArray.push(["\"" + title4.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + temp11.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title5 = 'Complete the diagnostic assessment (if applicable) within the first 6 weeks of your programme.'
          let title12 = 'To provide an appeals procedure for learners who disagree with advice or an assessment decision. Full details of the appeals procedure are given to all learners either via E-Portfolio or their Awarding Organisation standards. The contact details required by learners are detailed on Page2.'
          finalArray.push(["\"" + title5.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title12.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title6 = 'Communicate to the Training Provider any changes in situation.'
          let title13 = 'To safeguard all learners in line with company policies and procedures.'
          finalArray.push(["\"" + title6.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title13.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title7 = 'Ensure that all work submitted towards your qualification is your own work.Plagiarism is taken very seriously within Profound Group and this could result in the termination of your qualification.'
          let title14 = 'Carry out a thorough assessment to identify the additional learning support (Additional Funding) the Apprentice needs and if appropriate record in the ILR that an Apprentice has a learning support need.'
          finalArray.push(["\"" + title7.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title14.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title15 = 'Agree and record the outcomes of the additional learning support assessment,deliver support in line with the identified needs, record all outcomes in the evidence pack,and retain evidence of the assessment.'
          let temp15 = title15.replace(/,/g, " ")
          // finalArray.push([temp15], ['\r'])
          finalArray.push(['', "\"" + temp15.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'], ['\r'])
          let title16 = 'I agree that I have been involved in drawing up this plan to understand,and agree with its contents and to my responsibilities detailed above:'
          let temp16 = title16.replace(/,/g, " ")
          finalArray.push(["\"" + temp16.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          finalArray.push(['LearnerDate', item.learnerDate1 && item.learnerDate1 != null ? moment(item.learnerDate1).format("DD-MM-YYYY") : '-'], ['\r'])
          finalArray.push(['TrainerDate', item.taDate1 && item.taDate1 != null ? moment(item.taDate1).format("DD-MM-YYYY") : '-'], ['\r'])
        }
      } else {
        console.log("this is for level 3 jobs");
        finalArray.push(['personalDetails'], ['\r'], ['\r'])

        if (learnerFormData.personalDetails) {
          finalArray.push(['LearnerDetails'], ['\r'])
          let headers = ['Learner Name', 'Tel. No', 'Date Of Birth', 'Age']
          finalArray.push(headers, ['\r'])
          let item = learnerFormData.personalDetails
          console.log("item value of date", item);

          let temp = []
          temp.push(item.name, item.telNo, moment(item.dob).format("DD-MM-YYYY"), item.age)
          console.log("what is the total temp value", temp);
          finalArray.push(temp, ['\r'], ['\r'])
          if (item.taDetails && item.taDetails.length) {
            finalArray.push(['TA Name', 'TA Tel. No'], ['\r'])
            item.taDetails.forEach((single) => {
              let temp = []
              temp.push(single.name, single.telNo)
              finalArray.push(temp, ['\r'])
            })
            finalArray.push(['\r'])
          }
          if (item.iqaDetails && item.iqaDetails.length) {
            finalArray.push(['IQA Name', 'IQA Tel. No'], ['\r'])
            item.iqaDetails.forEach((single) => {
              let temp = []
              temp.push(single.name, single.telNo)
              finalArray.push(temp, ['\r'])
            })
            finalArray.push(['\r'])
          }
          if (item.erDetails && item.erDetails.length) {
            finalArray.push(['Emergency Name', 'Emergency Tel. No'], ['\r'])
            item.erDetails.forEach((single) => {
              let temp = []
              temp.push(single.name, single.telNo)
              finalArray.push(temp, ['\r'])
            })
            finalArray.push(['\r'])
          }
          finalArray.push(['Start Date', 'Expected End Date', 'Actual End Date', 'Planned Duration'], ['\r'])
          finalArray.push([moment(item.startDate).format("DD-MM-YYYY"), moment(item.expectedEndDate).format("DD-MM-YYYY"), moment(item.actualEndDate).format("DD-MM-YYYY"), item.duration], ['\r'], ['\r'])

        }

        if (learnerFormData.qualificationsForm) {
          finalArray.push(['Qualification Details'], ['\r'])
          let headers = ['Qualification', 'Learning Aim No', 'Awarding Organisation', 'Planned Learning Hours', 'Start Date', 'End Date']
          finalArray.push(headers, ['\r'])

          let item = learnerFormData.qualificationsForm
          let temp = []
          temp.push(item.qualification, item.learningAim, item.awardingOrg, item.plannedHrs, moment(item.startDate).format("DD-MM-YYYY"), moment(item.endDate).format("DD-MM-YYYY"))
          finalArray.push(temp, ['\r'], ['\r'])
        }
        if (learnerFormData.centerDetails) {
          finalArray.push(['Center Details'], ['\r'])
          let headers = ['Provider Name', 'Provider Address', 'Tel. No.', 'Email']
          finalArray.push(headers, ['\r'])
          let item = learnerFormData.centerDetails
          let temp = []
          temp.push(item.name, item.address, item.telNo, item.email)
          finalArray.push(temp, ['\r'], ['\r'])
        }

        if (learnerFormData.assessment) {
          finalArray.push(['Initial Assessment / Diagonastic Results'], ['\r'])
          let headers = ['Subject', 'Score', 'Level']
          finalArray.push(headers, ['\r'])

          let item = learnerFormData.assessment
          let temp = []
          let temp1 = []
          temp.push('English', item.engScore, item.engLevel)
          finalArray.push(temp, ['\r'])
          temp1.push('Maths', item.mathScore, item.mathLevel)
          finalArray.push(temp1, ['\r'], ['\r'])
        }
        if (learnerFormData.aln) {
          finalArray.push(['Additional Learning Needs'], ['\r'])
          let headers = ['None', 'ASN - Maths', 'ALN - both', 'ASN - English', 'ASN']
          finalArray.push(headers, ['\r'])
          let item = learnerFormData.aln
          let temp = []
          temp.push(item.aln1, item.aln2, item.aln3, item.aln4, item.aln5)
          finalArray.push(temp, ['\r'], ['\r'])
        }
        if (learnerFormData.IAG) {
          let item = learnerFormData.IAG
          finalArray.push(['Three Stages of Information, Advice and Guidance (IAG)'], ['\r'], ['\r'])
          let title = "\"" + 'Getting into Learning: To be recorded as part of learner sign up e.g. ensuring programme is appropriate, assessing current skills and needs,identifying career goals and aspirations, discussing concerns and agreeing how needs will be met to ensure progression and learning style to meet objectives.' + "\""
          let title1 = "\"" + 'Review:To be recorded at mid-point of programme e.g. providing ongoing support to help maintain pace and momentum, reviewing goals and agreeing future options and actions required.' + "\""
          let title2 = "\"" + 'Moving on from Learning:To be recorded on learner exit e.g. discussing progression options into further learning and development that is appropriate to the learners needs what actions are required within appropriate timescales.Signposting learners to appropriate resources and organisations if applicable.' + "\""
          let temp
          temp = title.replace(/,/g, "|")
          // console.log("description value============", temp);
          if (item.value1) {
            finalArray.push([temp.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next)], ['\r'])
            finalArray.push(['Comments'], ['\r'])
            finalArray.push([item.comment1], ['\r'])
            finalArray.push(["\"" + item.value1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
            let secondDate = []
            // firstDate.push('LearnerDate', item.learnerDate1)
            // finalArray.push(firstDate, ['\r'])
            secondDate.push('TrainerDate', moment(item.trainerDate1).format("DD-MM-YYYY"))
            finalArray.push(secondDate, ['\r'])
          }
          if (item.value2) {
            let temp1 = title1.replace(/,/g, "|")
            finalArray.push(["\"" + temp1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
            finalArray.push(['Comments'], ['\r'])
            finalArray.push([item.comment2], ['\r'])
            finalArray.push(["\"" + item.value2.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
            let secondDate = []
            // firstDate.push('LearnerDate', item.learnerDate2)
            // finalArray.push(firstDate, ['\r'])
            secondDate.push('TrainerDate', moment(item.trainerDate2).format("DD-MM-YYYY"))
            finalArray.push(secondDate, ['\r'])
          }
          if (item.value3) {
            let temp1 = title2.replace(/,/g, "|")
            finalArray.push(["\"" + temp1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
            finalArray.push(['Comments'], ['\r'])
            finalArray.push([item.comment3], ['\r'])
            finalArray.push(["\"" + item.value3.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
            let secondDate = []
            // firstDate.push('LearnerDate', item.learnerDate3)
            // finalArray.push(firstDate, ['\r'])
            secondDate.push('TrainerDate', moment(item.trainerDate3).format("DD-MM-YYYY"))
            finalArray.push(secondDate, ['\r'], ['\r'])
          }
        }

        if (learnerFormData.alpQualification) {
          let item = learnerFormData.alpQualification
          finalArray.push(['APL'], ['\r'], ['\r'])
          finalArray.push(['What are your personal goals while attending this programme?'], ['\r'])
          if (learnerFormData.alpQualification && learnerFormData.alpQualification.personalGoal) {
            finalArray.push(["\"" + item.personalGoal.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'], ['\r'])
          }

          finalArray.push(['Qualification (Title & Level):'], ['\r'])
          if (item.qualification && item.qualification.length) {
            // finalArray.push(['Unit Number',])
            let temp = ['Unit Number']
            item.qualification.forEach((single) => {
              temp.push(single.unitNo)
            })
            finalArray.push(temp, ['\r'])
          }
          if (item.qualification && item.qualification.length) {
            // finalArray.push(['Unit Level',])
            let temp = ['Unit Level']
            item.qualification.forEach((single) => {
              temp.push(single.unitLevel)
            })
            finalArray.push(temp, ['\r'])
          }
          if (item.qualification && item.qualification.length) {
            // finalArray.push(['Unit Credit Value',])
            let temp = ['Unit Credit Value']
            item.qualification.forEach((single) => {
              temp.push(single.unitCredit)
            })
            finalArray.push(temp, ['\r'])
          }
          if (item.qualification && item.qualification.length) {
            // finalArray.push(['State if APL',])
            let temp = ['State if APL']
            item.qualification.forEach((single) => {
              temp.push(single.unitApl)
            })
            finalArray.push(temp, ['\r'], ['\r'])
          }
          finalArray.push(['Qualification Proportion of Funding'], ['\r'])
          finalArray.push(['Total Credits of Aim', item.fundingTotalCredits], ['\r'])
          finalArray.push(['Remaining Credits following APL', item.fundingRemaining], ['\r'])
          finalArray.push(['Proportion of Funding Remaining', item.propertionRemaining], ['\r'], ['\r'])
        }



        if (learnerFormData.rpl) {
          let item = learnerFormData.rpl
          finalArray.push(['RPL'], ['\r'], ['\r'])
          finalArray.push(['Competency Aim (Title & Level): Level 3 Diploma in Engineering Technology -Rail'])
          if (item.unitDetails && item.unitDetails.length) {
            for (let i = 0; i < item.unitDetails.length; i++) {
              finalArray.push([','])
            }
          }
          finalArray.push([','], ['Total'], ['\r'])

          if (item.unitDetails && item.unitDetails.length) {
            // finalArray.push(['Unit Number',])
            let temp = ['Unit Number']
            item.unitDetails.forEach((single) => {
              temp.push(single.unitNo)
            })
            temp.push(item.rowTotal)
            finalArray.push(temp, ['\r'])
          }
          if (item.unitDetails && item.unitDetails.length) {
            // finalArray.push(['Unit Level',])
            let temp = ['Number of Outcomes']
            item.unitDetails.forEach((single) => {
              temp.push(single.outcomes)
            })
            temp.push(item.rowTotal1)
            finalArray.push(temp, ['\r'])
          }
          if (item.unitDetails && item.unitDetails.length) {
            // finalArray.push(['Unit Credit Value',])
            let temp = ['Never']
            item.unitDetails.forEach((single) => {
              temp.push(single.never)
            })
            temp.push(item.rowTotal2)
            finalArray.push(temp, ['\r'])
          }
          if (item.unitDetails && item.unitDetails.length) {
            // finalArray.push(['State if APL',])
            let temp = ['Sometimes']
            item.unitDetails.forEach((single) => {
              temp.push(single.sometimes)
            })
            temp.push(item.rowTotal3)
            finalArray.push(temp, ['\r'])
          }
          if (item.unitDetails && item.unitDetails.length) {
            // finalArray.push(['State if APL',])
            let temp = ['Always']
            item.unitDetails.forEach((single) => {
              temp.push(single.always)
            })
            temp.push(item.rowTotal4)
            finalArray.push(temp, ['\r'])
          }
          if (item.unitDetails && item.unitDetails.length) {
            // finalArray.push(['State if APL',])
            let temp = ['Total']
            item.unitDetails.forEach((single) => {
              temp.push(single.total)
            })
            temp.push(item.rowTotal5)
            finalArray.push(temp, ['\r'], ['\r'])
          }
          finalArray.push(['Qualification Proportion of Funding'], ['\r'])
          finalArray.push(['Total Credits of Aim', item.fundingTotalCredits], ['\r'])
          finalArray.push(['Remaining Credits following APL', item.fundingRemaining], ['\r'])
          finalArray.push(['Proportion of Funding Remaining', item.propertionRemaining], ['\r'], ['\r'])
        }

        if (learnerFormData.learningAnalysis) {
          finalArray.push(['Learning Needs Analysis'], ['\r'], ['\r'])
          let headers = ['Unit Title ', ' Unit No', 'Learning Outcome ', 'How will I learn?', 'Assessment Method', ' Planned End Date', 'Actual Completion Date']
          finalArray.push(headers, ['\r'])
          let item = learnerFormData.learningAnalysis

          if (item.lna && item.lna.length) {

            item.lna.forEach((single) => {
              let temp = []
              temp.push(single.unitTitle, single.unitNo, single.outcome, single.howToLearn, single.assessment, moment(single.plannedDate).format("DD-MM-YYYY"), moment(single.actualDate).format("DD-MM-YYYY"))
              finalArray.push(temp, ['\r'])
            })
          }

          if (item && !item.lna) {

            item.forEach((single) => {
              let temp = []
              temp.push(single.unitTitle, single.unitNo, single.outcome, single.howToLearn, single.assessment, moment(single.plannedDate).format("DD-MM-YYYY"), moment(single.actualDate).format("DD-MM-YYYY"))
              finalArray.push(temp, ['\r'])
            })
          }

          finalArray.push(['\r'])
        }


        if (learnerFormData.responsibility) {
          let item = learnerFormData.responsibility
          finalArray.push(['Responsibilities'], ['\r'], ['\r'])
          finalArray.push(['The Learners Responsibilities', 'The Training Providers Responsibilities'], ['\r'])
          let title1 = 'In both working and training to be,diligent and punctual, to attend courses,keep records and contribute to the review process, undertake assessments in order to achieve Individual Learning Plan objectives and keep the employer informed of progress towards those objectives'
          let temp1 = title1.replace(/,/g, " ")
          let title8 = 'To check that the contents of the Individual Learning Plan fulfil the national and industry / sector agreed criteria for the programme.'
          finalArray.push(["\"" + temp1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title8.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let titel2 = 'At all times to behave in a safe and responsible manner and in accordance with the requirements of health and safety legislation relating to the individuals responsibilities and to promote and act in the employers best interests.'
          let title9 = 'To conduct a progress review with the learner and employer at least every 8 weeks.'
          finalArray.push(["\"" + titel2.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title9.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title3 = 'Commit to making sure evidence is submitted in line with SMART targets.'
          let title10 = 'To deliver the programme as described in this plan, and in line with the appropriate framework awarding organisation and end point assessment (if applicable) requirements.'
          let temp10 = title10.replace(/,/g, " ")
          finalArray.push(["\"" + title3.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + temp10.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title4 = 'Communicate all non-attendance or session changes within a timely manner.'
          let title11 = 'To ensure that the training meets the requirements set out in the contract between the Training Provider and the Skills Funding Agency, in particular in relation to the quality assurance process including health and safety obligations.'
          let temp11 = title11.replace(/,/g, " ")
          finalArray.push(["\"" + title4.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + temp11.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title5 = 'Complete the diagnostic assessment (if applicable) within the first 6 weeks of your programme.'
          let title12 = 'To provide an appeals procedure for learners who disagree with advice or an assessment decision. Full details of the appeals procedure are given to all learners either via E-Portfolio or their Awarding Organisation standards. The contact details required by learners are detailed on Page2.'
          finalArray.push(["\"" + title5.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title12.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title6 = 'Communicate to the Training Provider any changes in situation.'
          let title13 = 'To safeguard all learners in line with company policies and procedures.'
          finalArray.push(["\"" + title6.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title13.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title7 = 'Ensure that all work submitted towards your qualification is your own work.Plagiarism is taken very seriously within Profound Group and this could result in the termination of your qualification.'
          let title14 = 'Carry out a thorough assessment to identify the additional learning support (Additional Funding) the Apprentice needs and if appropriate record in the ILR that an Apprentice has a learning support need.'
          finalArray.push(["\"" + title7.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title14.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title15 = 'Agree and record the outcomes of the additional learning support assessment,deliver support in line with the identified needs, record all outcomes in the evidence pack,and retain evidence of the assessment.'
          let temp15 = title15.replace(/,/g, " ")
          // finalArray.push([temp15], ['\r'])
          finalArray.push(['', "\"" + temp15.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'], ['\r'])
          let title17 = 'We are unable to offer a fully-funded first full level 3 for this programme of learning, we have signposted the learner to the National Careers Service to obtain information about alternative providers. Therefore, as you have chosen to apply for loan rather than exercising your legal entitlement to full funding for a first full level 3 qualification, you are aware that this may mean you give up your right to exercise your legal entitlement in future.'
          let temp17 = title17.replace(/,/g, " ")
          finalArray.push(["\"" + temp17.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let title18 = 'I agree that I understand that I may give up my right to a fully funded level 3 qualification'
          finalArray.push(["\"" + title18.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          finalArray.push(['LearnerDate', item.learnerDate1 && item.learnerDate1 != null ? moment(item.learnerDate1).format("DD-MM-YYYY") : '-'], ['\r'])
          finalArray.push(['TrainerDate', item.taDate1 && item.taDate1 != null ? moment(item.taDate1).format("DD-MM-YYYY") : '-'], ['\r'])
          let title19 = 'I agree that I have been involved in drawing up this plan to understand, and agree with its contents and to my responsibilities detailed above: '
          let temp19 = title19.replace(/,/g, " ")
          finalArray.push(["\"" + temp19.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])

          let title16 = 'I agree that I have been involved in drawing up this plan to understand,and agree with its contents and to my responsibilities detailed above:'
          let temp16 = title16.replace(/,/g, " ")
          finalArray.push(["\"" + temp16.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          finalArray.push(['LearnerDate', item.learnerDate2 && item.learnerDate2 != null ? moment(item.learnerDate2).format("DD-MM-YYYY") : '-'], ['\r'])
          finalArray.push(['TrainerDate', item.taDate2 && item.taDate2 != null ? moment(item.taDate2).format("DD-MM-YYYY") : '-'], ['\r'])
        }

      }


      console.log("final array to print=======", finalArray);

      if (finalArray && finalArray.length) {

        let str = "";
        finalArray.forEach(row => {
          let line = "";
          let columns =
            typeof row !== "object" ? JSON.parse(row) : Object.values(row);
          columns.forEach(column => {
            if (line !== "") {
              line += ";";
            }
            if (typeof column === "object") {
              line += JSON.stringify(column);
            } else {
              line += column;
            }
          });
          str += line + "\r\n";
        });


        let blob = new Blob(finalArray, { type: 'text/csv;charset=utf-8;' });
        // let name = learnerName
        // let title = jobName ? jobName + "Register" : 'Register'
        let location = []
        job.clients.forEach((item) => {
          location.push(item.location.title)
        })
        let title = 'Individual-Learner-Profile_' + location.join('-') + '_' + moment(new Date).format("DD-MM-YYYY")
        saveAs(blob, title + ".csv");
        // res['data'] = string
      }
      let string = 'FILE DOWNLOAD'
      console.log("this observable is called");

      observer.next(string)

      observer.complete()

      console.log("observable complete");

      // return 'FILE DOWNLOAD'
    });
  }


  downloadLearnerForm(data): Observable<any> {

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "document/downloadlearnerform", data).subscribe((res: any) => {
        console.log("pdf buffer : ", res.data);
        let byteArray = new Uint8Array(res.data.data);
        console.log("======byteArray =======", byteArray)
        let blob = new Blob([byteArray], { type: 'application/pdf' });
        console.log("blobblobblobblobblob", blob)
        let title
        let name = data.personalDetails.name.split(' ').join('_')
        if (data.templateName == 'ilp-form') {
          title = name + '_ilp' + '_' + moment(new Date).format("DD-MM-YYYY") + '.pdf'
        } else if (data.templateName == 'rap-form') {
          title = name + '_rap' + '_' + moment(new Date).format("DD-MM-YYYY") + '.pdf'
        }
        saveAs(blob, title);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  downloadIlpFormPdf(data): Observable<any> {

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "document/downloadilpform", data).subscribe((res: any) => {
        console.log("pdf buffer : ", res.data);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }
  downloadAllRaps(data): Observable<any> {
    return new Observable<any>((observer) => {
      this.http.post(config.baseApiUrl + "document/downloadrapform", data).subscribe((res: any) => {
        console.log("pdf buffer : ", res.data);
        observer.next(res.data);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  // downloadRapForm(data): Observable<any> {

  //   return new Observable<any>((observer) => {
  //     console.log("Observable");
  //     this.http.post(config.baseApiUrl + "document/downloadrapform", data).subscribe((res: any) => {
  //       console.log("pdf buffer : ", res.data);
  //       observer.next(res);
  //     }, err => {
  //       observer.error(err)
  //     }, () => {
  //       observer.complete();
  //     })
  //   });
  // }




  getIqaData(data) {
    console.log("what is the data", data);
    this.assignment.next({ data })
  }


  getAssignmentObservable(): Observable<any> {
    return this.assignment.asObservable();
  }

  download(data): Observable<any> {

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "document/download", data).subscribe((res: any) => {
        console.log("pdf buffer : ", res.data);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

}
